"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.JuneoReader = exports.JuneoBuffer = exports.BytesData = void 0;
const encoding = __importStar(require("./encoding"));
const errors_1 = require("./errors");
class BytesData {
    buffer;
    bytes;
    constructor(buffer) {
        this.buffer = buffer;
        this.bytes = this.buffer.getBytes();
    }
    getBuffer() {
        return this.buffer;
    }
    serialize() {
        return JuneoBuffer.fromBytes(this.bytes);
    }
    static comparator = (a, b) => a.bytes.compare(b.bytes);
}
exports.BytesData = BytesData;
/**
 * Buffer wrapper that has methods compatible with the Juneo platform encoding format.
 *
 * Bytes are in big endian format and can be encoded/decoded in hex, CHex or CB58
 */
class JuneoBuffer {
    bytes;
    cursor = 0;
    length;
    constructor(size) {
        if (size < 0) {
            throw new errors_1.CapacityError('cannot allocate negative size');
        }
        this.bytes = Buffer.alloc(size);
        this.length = size;
    }
    getCursor() {
        return this.cursor;
    }
    createReader() {
        return new JuneoReader(this);
    }
    verifyWriteIndices(length) {
        if (this.cursor + length > this.length) {
            throw new errors_1.CapacityError(`writing at ${this.cursor} with length of ${length} to capacity of ${this.length}`);
        }
    }
    write(data) {
        if (!(data instanceof JuneoBuffer)) {
            data = data.serialize();
        }
        this.writeBuffer(data.bytes);
    }
    writeBuffer(data) {
        this.verifyWriteIndices(data.length);
        const written = this.cursor === 0 ? Buffer.alloc(0) : this.bytes.subarray(0, this.cursor);
        this.bytes = Buffer.concat([written, data], this.length);
        this.cursor += data.length;
    }
    writeUInt8(data) {
        this.verifyWriteIndices(1);
        this.cursor = this.bytes.writeUInt8(data, this.cursor);
    }
    writeUInt16(data) {
        this.verifyWriteIndices(2);
        this.cursor = this.bytes.writeUInt16BE(data, this.cursor);
    }
    writeUInt32(data) {
        this.verifyWriteIndices(4);
        this.cursor = this.bytes.writeUInt32BE(data, this.cursor);
    }
    writeUInt64(data) {
        this.verifyWriteIndices(8);
        this.cursor = this.bytes.writeBigUInt64BE(data, this.cursor);
    }
    writeString(data, encoding = 'utf8') {
        this.verifyWriteIndices(data.length);
        // Buffer.write returns the amount of bytes written instead of the cursor
        this.cursor += this.bytes.write(data, this.cursor, encoding);
    }
    verifyReadIndices(index, length) {
        if (index < 0) {
            throw new errors_1.CapacityError(`cannot read at negative index but got ${index}`);
        }
        if (length < 1) {
            throw new errors_1.CapacityError(`read length must be greater than 0 but got ${length}`);
        }
        if (index + length > this.length) {
            throw new errors_1.CapacityError(`reading at ${index} with length of ${length} to capacity of ${this.length}`);
        }
        if (index === null || length === null) {
            throw new errors_1.CapacityError(`cannot have null indices or length but got ${index} and ${length}`);
        }
    }
    readUInt8(index) {
        this.verifyReadIndices(index, 1);
        return this.bytes.readUInt8(index);
    }
    readUInt16(index) {
        this.verifyReadIndices(index, 2);
        return this.bytes.readUInt16BE(index);
    }
    readUInt32(index) {
        this.verifyReadIndices(index, 4);
        return this.bytes.readUInt32BE(index);
    }
    readUInt64(index) {
        this.verifyReadIndices(index, 8);
        return this.bytes.readBigUInt64BE(index);
    }
    readString(index, length, encoding = 'utf8') {
        this.verifyReadIndices(index, length);
        return this.read(index, length).bytes.toString(encoding);
    }
    read(index, length) {
        this.verifyReadIndices(index, length);
        return JuneoBuffer.fromBytes(this.bytes.subarray(index, index + length));
    }
    toCB58() {
        return encoding.encodeCB58(this);
    }
    toCHex() {
        return encoding.encodeCHex(this);
    }
    toHex() {
        return this.bytes.toString('hex');
    }
    getBytes() {
        return Buffer.from(this.bytes);
    }
    copyOf(start = 0, end = this.length) {
        return this.read(start, end - start);
    }
    static alloc(size) {
        return new JuneoBuffer(size);
    }
    static concat(buffers) {
        const data = [];
        let length = 0;
        for (const buffer of buffers) {
            data.push(buffer.bytes);
            length += buffer.bytes.length;
        }
        return JuneoBuffer.fromBytes(Buffer.concat(data, length));
    }
    static fromBytes(bytes) {
        const buffer = new JuneoBuffer(bytes.length);
        buffer.writeBuffer(bytes);
        return buffer;
    }
    static fromString(data, fromEncoding) {
        if (data === '') {
            throw new errors_1.ParsingError('parsed data cannot be empty');
        }
        if (fromEncoding === undefined) {
            const isHex = encoding.isHex(data);
            if (isHex) {
                const hasChecksum = encoding.verifyChecksum(encoding.decodeHex(data));
                fromEncoding = hasChecksum ? 'cHex' : 'hex';
            }
            else if (encoding.isBase58(data)) {
                fromEncoding = 'CB58';
            }
            else {
                throw new errors_1.ParsingError('parsed data is not hex, cHex or CB58');
            }
        }
        if (fromEncoding.toLowerCase() === 'hex') {
            return encoding.hasHexPrefix(data)
                ? JuneoBuffer.fromBytes(Buffer.from(data.substring(2), 'hex'))
                : JuneoBuffer.fromBytes(Buffer.from(data, 'hex'));
        }
        else if (fromEncoding.toLowerCase() === 'chex') {
            return encoding.decodeCHex(data);
        }
        else if (fromEncoding.toLowerCase() === 'cb58') {
            return encoding.decodeCB58(data);
        }
        else {
            throw new errors_1.ParsingError(`invalid encoding "${fromEncoding}" should be hex, cHex or CB58`);
        }
    }
    static from(data) {
        if (typeof data === 'string') {
            return JuneoBuffer.fromString(data);
        }
        return data;
    }
    static comparator = (a, b) => {
        return a.bytes.compare(b.bytes);
    };
}
exports.JuneoBuffer = JuneoBuffer;
class JuneoReader {
    buffer;
    cursor = 0;
    constructor(buffer) {
        this.buffer = buffer;
    }
    getCursor() {
        return this.cursor;
    }
    skip(amount) {
        if (typeof amount !== 'number') {
            amount = amount.serialize().length;
        }
        this.cursor += amount;
    }
    readUInt8() {
        const value = this.buffer.readUInt8(this.cursor);
        this.cursor += 1;
        return value;
    }
    readUInt16() {
        const value = this.buffer.readUInt16(this.cursor);
        this.cursor += 2;
        return value;
    }
    readUInt32() {
        const value = this.buffer.readUInt32(this.cursor);
        this.cursor += 4;
        return value;
    }
    readUInt64() {
        const value = this.buffer.readUInt64(this.cursor);
        this.cursor += 8;
        return value;
    }
    readString(length, encoding = 'utf8') {
        return this.read(length).getBytes().toString(encoding);
    }
    readAndVerifyTypeId(expectedTypeId) {
        const typeId = this.readUInt32();
        if (typeId !== expectedTypeId) {
            throw new errors_1.ParsingError(`invalid type id ${typeId} expected ${expectedTypeId}`);
        }
        return typeId;
    }
    read(length) {
        const value = this.buffer.read(this.cursor, length);
        this.cursor += length;
        return value;
    }
    readRemaining() {
        return this.read(this.buffer.length - this.cursor);
    }
    peekRemaining() {
        const value = this.buffer.read(this.cursor, this.buffer.length - this.cursor);
        return value;
    }
}
exports.JuneoReader = JuneoReader;
